import React from "react";
import ReservationBuilderDateSelector from "./ReservationBuilderDateSelector";
import ReservationBuilderActions from "./actions/ReservationBuilderActions";
// import { format } from 'date-fns';
import numeral from "numeral";

export default class ReservationBuilderAvailableAccommodations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ratesLoaded: false,
      showRates: false,
    };
    this.onViewRates = this.onViewRates.bind(this);
    this.onHideRates = this.onHideRates.bind(this);
    this.onSelectRate = this.onSelectRate.bind(this);
    this.onChangeRoomQuantityDropdown =
      this.onChangeRoomQuantityDropdown.bind(this);
  }

  /**
   * Render functions
   */

  render() {
    return (
        <div>
          <ReservationBuilderDateSelector {...this.props} />
          {this.renderAccommodations()}
        </div>

    );
  }

  renderAccommodations() {
    var self = this;

    if (!this.props.default_payment_gateway) {
      return null;
    }

    if (
      this.props.accommodations &&
      this.props.accommodations.room_types &&
      this.props.accommodations.room_types.length
    ) {
      var room_type_ids = [];
      var room_types = this.props.accommodations.room_types
        .sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        })
        .map(function (room_type) {
          if (
            room_type_ids.indexOf(room_type.id) == -1 &&
            !self.hasReservationSegment(room_type.reservation_segment_id)
          ) {
            room_type_ids.push(room_type.id);
            return self.renderRoomType(room_type);
          } else {
            return null;
          }
        });

      if (room_types && room_types.length) {
        room_types = this.cleanArray(room_types, null);
      }
    }

    if (room_types && room_types.length > 0) {
      return (
        <table className="table" ref="table">
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>{I18n.t("name")}</th>
              <th>{I18n.t("bed_type")}</th>
              <th>{I18n.t("availability")}</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          {room_types}
        </table>
      );
    } else {
      return (
        <p className="lead text-center none">
          {I18n.t("no_accommodations_available")}
        </p>
      );
    }
  }

  renderAccommodation(type, accommodation) {
    var number_of_rooms_available =
      this.calculateNumberOfRoomsAvailable(accommodation);
    return (
      <tbody
        key={accommodation.id + "|" + accommodation.reservation_segment_id}
      >
        <tr>
          <td>{this.renderImage(accommodation.image_group)}</td>
          <td>
            <a
              href={accommodation.show_path}
              className="modal-iframe"
              data-fullscreen="true"
            >
              <strong>{accommodation.name}</strong>
            </a>
          </td>
          <td>
            {accommodation.bed_type || (
              <span className="none">{I18n.t("none")}</span>
            )}
          </td>
          <td>
            {this.renderNumberOfRoomsAvailable(
              accommodation,
              number_of_rooms_available
            )}
          </td>
          <td className="text-right">
            {this.renderShowHideRates(accommodation, number_of_rooms_available)}
          </td>
        </tr>
        {this.renderRates(accommodation, number_of_rooms_available)}
      </tbody>
    );
  }

  renderShowHideRates(accommodation, number_of_rooms_available) {
    if (
      number_of_rooms_available > 0 &&
      ((accommodation.available_rates &&
        accommodation.available_rates.length) ||
        (accommodation.unavailable_rates &&
          accommodation.unavailable_rates.length))
    ) {
      if (
        this.props.accommodation_with_visible_rates &&
        this.props.accommodation_with_visible_rates.id == accommodation.id &&
        this.state.showRates
      ) {
        return (
          <button
            type="button"
            className="btn btn-link"
            onClick={this.onHideRates.bind(null, accommodation)}
          >
            {I18n.t("hide_rates")}
          </button>
        );
      } else {
        return (
          <button
            type="button"
            className="btn btn-link"
            onClick={this.onViewRates.bind(null, accommodation)}
          >
            {I18n.t("view_rates")}
          </button>
        );
      }
    } else {
      return (
        <span
          className="label label-default label-message"
          title={I18n.t("no_rooms_available")}
        >
          <span className="ss-ban" />
        </span>
      );
    }
  }

  renderNumberOfRoomsAvailable(accommodation, number_of_rooms_available) {
    if (this.props.master_reservation_id) {
      return <span>{number_of_rooms_available}</span>;
    } else {
      return (
        <span>
          {number_of_rooms_available}/
          {accommodation.number_of_rooms ||
            accommodation.number_of_room_groups ||
            1}
        </span>
      );
    }
  }

  renderImage(image_group) {
    if (image_group && image_group.images && image_group.images.length > 0) {
      return (
        <img
          src={image_group.images[0].thumb_medium_url}
          style={{ width: 69, height: "auto" }}
        />
      );
    } else {
      return null;
    }
  }

  renderRates(accommodation, number_of_rooms_available) {
    if (
      this.props.accommodation_with_visible_rates &&
      this.props.accommodation_with_visible_rates.id == accommodation.id &&
      this.state.showRates &&
      number_of_rooms_available > 0
    ) {
      return (
        <tr>
          <td colSpan="5" className="rates-td">
            <div className="accommodation-rates">
              {(accommodation.available_rates &&
                accommodation.available_rates.length) ||
              (accommodation.unavailable_rates &&
                accommodation.unavailable_rates.length) ? (
                this.renderLoadedRates(accommodation, number_of_rooms_available)
              ) : (
                <div className="loadingOverlay">
                  <div className="spinner spinner-sm"></div>
                </div>
              )}
            </div>
          </td>
        </tr>
      );
    }
  }

  renderLoadedRates(accommodation, number_of_rooms_available) {
    var self = this;
    var options = [];

    if (accommodation.type_of_booking == "room_group") {
      options.push({
        value: 1,
        name: I18n.t("one_room"),
      });
    } else {
      for (var i = 0; i < number_of_rooms_available; i++) {
        options.push({
          value: i + 1,
          name:
            i + 1 == 1
              ? I18n.t("one_room")
              : I18n.t("x_rooms", { number: i + 1 }),
        });
      }
    }

    var rates = accommodation.available_rates.map(function (rate) {
      return (
        <div key={rate.id} className="available-rate">
          <div className="rate-details">
            {rate.code}, {rate.name},{" "}
            {rate.average_amount
              ? "$" +
                numeral(rate.average_amount / 100).format(
                  self.props.numberFormat
                )
              : null}{" "}
            {I18n.t("avg_per_night")}
          </div>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={self.onSelectRate.bind(
              null,
              accommodation,
              self.props.check_in_date,
              self.props.check_out_date,
              rate
            )}
          >
            <div>{I18n.t("select")}</div>
          </button>
        </div>
      );
    });
    var unavailable_rates = accommodation.unavailable_rates.map(function (
      rate
    ) {
      return (
        <div
          key={rate.id}
          className="unavailable-rate"
          title={rate.unavailable_rationale}
        >
          <div className="rate-details">
            {rate.code}, {rate.name},{" "}
            {rate.average_amount
              ? "$" +
                numeral(rate.average_amount / 100).format(
                  self.props.numberFormat
                )
              : null}{" "}
            {I18n.t("avg_per_night")}
          </div>
          <button
            type="button"
            className="btn btn-secondary btn-select disabled"
          >
            {I18n.t("unavailable")}
          </button>
        </div>
      );
    });

    if (rates.length === 0 && unavailable_rates.length === 0) {
      return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          {I18n.t("no_rates_available")}
        </div>
      );
    }

    return (
      <div className="loaded-rates">
        {rates}
        {unavailable_rates}
      </div>
    );
  }

  renderRoomType(room_type) {
    return this.renderAccommodation("RoomType", room_type);
  }

  /**
   * Change handlers
   */

  onChangeRoomQuantityDropdown(
    accommodation,
    check_in_date,
    check_out_date,
    rate,
    value
  ) {
    this.onSelectRate(
      accommodation,
      check_in_date,
      check_out_date,
      rate,
      parseInt(value)
    );
  }

  onSelectRate(accommodation, check_in_date, check_out_date, rate, quantity) {
    var quantity = isNaN(quantity) ? 1 : quantity;
    var number_of_rooms_available =
      this.calculateNumberOfRoomsAvailable(accommodation);
    if (number_of_rooms_available <= 1) {
      this.setState({ ratesLoaded: false, rates: [], unavailable_rates: [] });
      ReservationBuilderActions.hideRates(accommodation);
    }

    ReservationBuilderActions.addReservationSegment(
      accommodation,
      check_in_date,
      check_out_date,
      rate,
      quantity
    );
  }

  onHideRates(accommodation) {
    this.setState({
      ratesLoaded: false,
      rates: [],
      unavailable_rates: [],
      showRates: true,
    });
    ReservationBuilderActions.hideRates(accommodation);
  }

  onViewRates(accommodation) {
    this.setState({
      ratesLoaded: false,
      rates: [],
      unavailable_rates: [],
      showRates: true,
    });
    ReservationBuilderActions.viewRates(accommodation);
    // this.loadRates(accommodation);
  }

  /**
   * Helper functions
   */

  calculateNumberOfRoomsAvailable(accommodation) {
    return accommodation.number_of_available_rooms;
  }

  cleanArray(arr, deleteValue) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == deleteValue) {
        arr.splice(i, 1);
        i--;
      }
    }
    return arr;
  }

  hasReservationSegment(reservation_segment_id) {
    for (
      var i = 0, ilen = this.props.reservation.reservation_segments.length;
      i < ilen;
      i++
    ) {
      if (
        this.props.reservation.reservation_segments[i].id ==
        reservation_segment_id
      ) {
        return true;
      }
    }

    return false;
  }
}
